import { EditBoxIcon } from '@common_components/icons/editBox.icon';
import { PlusIcon } from '@common_components/icons/plus.icon';
import { TrashIcon } from '@common_components/icons/trash.icon';
import React from 'react';
import ModalButton from '../buttons/modalButton.component';
import ModalButtonDelete from '../buttons/modalButtonDelete.component';
import ModalButtonCreateUpdate from '../buttons/modalButtonCreate.component';

interface ExtraButton {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  textColor?: string;
  bgColor?: string;
  borderColor?: string;
  hoverBorderColor?: string;
  width?: string;
  disable?: boolean;
}

interface ModalFooterProps {
  tableId?: string;
  formValid?: boolean;
  showButtons?: boolean;
  onCreate: () => void;
  onUpdate?: () => void;
  onDelete?: () => void;
  extraButtons?: ExtraButton[];
}

const BottomModal: React.FC<ModalFooterProps> = ( {
  tableId,
  showButtons = true,
  formValid = true,
  onCreate,
  onUpdate,
  onDelete,
  extraButtons = [],
} ) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 font-semibold px-5 py-3 bg-white-base w-full border-t rounded-b-xl border-t-gray-200">
      {showButtons && (
        <>
          <div className="flex-1 flex flex-wrap items-center gap-2">
            {onDelete && tableId && (
              <div className="w-full sm:w-auto">
                <ModalButtonDelete
                  icon={<TrashIcon size={5} />}
                  onClick={onDelete}
                />
              </div>
            )}

            {extraButtons.map( ( btn, i ) => {return (
              <div key={i} className="w-full sm:w-auto">
                <ModalButton
                  label={btn.label}
                  icon={btn.icon}
                  onClick={btn.onClick}
                  textColor={btn.textColor}
                  bgColor={btn.bgColor}
                  borderColor={btn.borderColor}
                  hoverBorderColor={btn.hoverBorderColor}
                  width={btn.width}
                  disable={btn.disable}
                />
              </div>
            );} )}
          </div>

          <div className="w-full sm:w-auto flex justify-end mt-2 sm:mt-0">
            <ModalButtonCreateUpdate
              iconCreate={<PlusIcon size={5} />}
              iconUpdate={<EditBoxIcon size={5} />}
              create={tableId ? false : true}
              onCreateClick={onCreate}
              onUpdateClick={onUpdate}
              disable={!formValid}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default BottomModal;
